<div class="d-flex">
  <div class="tooltip-custom {{ position }} fadeIn" [class.outline]="outline" [ngClass]="className" [innerHTML]="text"></div>
</div>
